import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
import { GenerateWalletTxnId, GenerateOnlineTxnId } from '../../components/GenerateThink5whysCode';
import razorpaysleek from '../../assets/pageimages/razorpaysleek.webp';
import paymentgateways from '../../assets/pageimages/paymentgateways.webp';

const MyWalletPayTemp = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();
  const navigate = useNavigate();
  const [amount, setAmount] = useState(100); 
  const [paymentClicked, setPaymentClicked] = useState(false);
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);
  const [onlinePaymentClicked, setOnlinePaymentClicked] = useState(false);
  const [particulars, setParticulars] = useState('');
  const [remarks, setRemarks] = useState('');
  const [modePayment, setModePayment] = useState('UPI');
  const [walletTransactionId, setWalletTransactionId] = useState('');
  const [transactionId, setTransactionId] = useState(GenerateOnlineTxnId());
  const [transactionDate] = useState(new Date());
  const [transactionStatus, setTransactionStatus] = useState('');
  // const [paymentDetails, setPaymentDetails] = useState('[Transaction ID: _______________][Sender UPI ID: _____________@_________]');
  const [paymentDetails, setPaymentDetails] = useState('');

  const handlePayment = () => {
    if (!amount) {
      alert('Please enter an amount.');
      return;
    } 
    if (modePayment === "Direct Referral Incentive" && (amount < 25 || amount > 165)) {
      alert('Amount should not be more than 165 or less than 25 for Direct Referral Incentive');
      return;
    }
    if (modePayment !== "Direct Referral Incentive" && amount < 100) {
      alert('Amount should not be less than 100');
      return;
    } else if (amount > 5000) {
      alert('Amount should not be greater than 5000');
      return;
    }
  
    // console.log(`temp payment for ${amount}`);
    setPaymentClicked(true);
  };

  const handlePaymentClicked = () => {
    saveWalletTemp();
    setPaymentConfirmed(true);
  };

  const saveWalletTemp = async () => {
    const userId = authState.user._id;
    const requestData = {
      userId,
      dateTransaction: new Date(),
      particulars: particulars,
      amount: amount,
      currency: 'Credits',
      remarks: remarks,
      modePayment,
      walletTransactionId,
      transactionId,
      transactionDate,
      transactionStatus: true,
      paymentDetails: paymentDetails,
      isActive: 1,
      isDeleted: 0,
      dateCreated: new Date(),
      createdBy: userId,
      isApproved: true,   //false,
      transferredBy: '',
      dateTransferred: new Date()
    };

    // console.log('Saving wallet temp data:', requestData);
    try {
      const config = {
        url: '/wallettemp/paytemp',
        method: 'post',
        data: requestData,
        headers: { Authorization: authState.token },
      };
      await fetchData(config);
    } catch (error) {
      console.error('Error saving wallet pay temp:', error);
    }
  };

  
  const handleCheckWalletTemp = () => {
    navigate('/wallet-mywallettemp');
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
      <div className="bg-gray-900 [&_p]:text-gray-100 text-white text-center py-4 px-4">
        <h2 className="text-sm lg:text-lg font-semibold mb-4 text-yellow-200">Pay by Other Methods</h2>

        <div className="bg-gray-800 rounded-lg shadow-md p-6 mx-auto">
          <label className="block text-white text-xs lg:text-sm font-medium mb-2">
            Mode*:
          </label>
          <select
            name="modePayment"
            id="modePayment"
            value={modePayment}
            onChange={e => setModePayment(e.target.value)}
            style={{height: "36px"}}
            className="text-xs lg:text-sm block w-full px-4 py-2 mb-4 border rounded-md text-gray-800"
          >
            <option value="" disabled>Select a payment mode</option>
            <option value="UPI payment to think5whys@hdfc">UPI payment to think5whys@hdfc</option>
            <option value="Direct Referral Incentive">Direct Referral Incentive</option>
          </select>
          <label className="block text-white text-xs lg:text-sm  font-medium mb-2">
            Amount*:
          </label>
          <input
            type="number"
            name="amount"
            id="amount"
            value={amount}
            placeholder="100"
            min="100"
            max={modePayment === "Direct Referral Incentive" ? 165 : 5000} 
            onChange={e => setAmount(e.target.value)}
            className="block text-xs lg:text-sm w-full px-4 py-2 mb-4 border rounded-md text-gray-800"
            style={{ width: '150px' }}
          />
          
          <label className="block text-xs lg:text-sm  text-white font-medium mb-2">
            {modePayment === "Direct Referral Incentive" ? "Customer Think5Whys Code" : "Payment Details (Transaction ID/Sender UPI Id)"} 
          </label>
          <input
            type="text"
            name="paymentDetails"
            id="paymentDetails"
            placeholder={modePayment === "Direct Referral Incentive" ? "Enter Customer Think5Whys Code" : "UPI transaction ID:_________, Sender UPI ID:_________"} 
            value={paymentDetails}
            onChange={e => setPaymentDetails(e.target.value)}
            className="block w-full px-4 py-2 mb-4 border rounded-md text-gray-800 text-xs lg:text-sm "
            style={{ width: '100%' }}
          />

          <label className="block text-white text-xs lg:text-sm  font-medium mb-2"> Product/Particulars: </label>
          <input
            type="text"
            name="particulars"
            id="particulars"
            value={particulars}
            onChange={e => setParticulars(e.target.value)}
            className="block text-xs lg:text-sm w-full px-4 py-2 mb-4 border rounded-md text-gray-800"
            style={{width: '100%'}}
          />
          <label className="block text-xs lg:text-sm text-white font-medium mb-2">
            Remarks:
          </label>
          <input
            type="text"
            name="remarks"
            id="remarks"
            value={remarks}
            onChange={e => setRemarks(e.target.value)}
            className="block text-xs lg:text-sm w-full px-4 py-2 mb-4 border rounded-md text-gray-800"
            style={{width: '100%'}}
          />
          <p className='text-cyan-200 text-xs lg:text-sm'>By submitting this form, I confirm that the above information is true. In case of any discrepancy, Think5Whys Global DeepTech Solutions Private Limited reserves the right to block my account or my referrer's account until the dispute is resolved amicably.</p>
          <button
            disabled={paymentClicked}
            onClick={handlePayment}
            className="w-fit px-4 py-2 text-xs lg:text-sm bg-blue-500 hover:bg-blue-600 text-white font-bold rounded"
          >
            I Paid
          </button>

          {paymentClicked && (
            <div className="mt-4">
              <button
                type="button"
                className="w-fit px-4 py-2 text-xs lg:text-sm bg-green-800 hover:bg-green-900 text-white rounded-md font-medium mb-4"
                onClick={handlePaymentClicked}
                disabled={paymentConfirmed}
              >
                Confirm
              </button>
              {paymentConfirmed && (
                <div className="p-4 rounded-lg">
                  <button
                    type="button"
                    className="w-full text-xs lg:text-sm bg-green-800 hover:bg-green-900 text-white py-2 rounded-md font-medium mt-4"
                    onClick={handleCheckWalletTemp}
                  >
                    Check Payment Record
                  </button>
                </div>
              )}
            </div>
          )}
          <div>
            <button
              onClick={handleCancel}
              className="w-fit text-xs lg:text-sm bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
            >
              Back
            </button>
          </div>
        </div>
      </div>
  );
};

export default MyWalletPayTemp;
